<app-page-container>
  <app-header appTitle="Histórico de Chamados" divider>
    <app-botao-voltar></app-botao-voltar>
  </app-header>
  <div class="c-conteudo">
    <h5 class="c-conteudo__titulo">Sobre o chamado</h5>
    <ng-container *ngFor="let detalheOS of detalhesOS.registros">
      <app-datails-card class="c-conteudo__container">
        <p *ngIf="detalheOS.codigoOS" class="c-conteudo__texto"><span class="u-font-weight-600">Código do chamado:
          </span>{{detalheOS.codigoOS}}
        </p>
        <p *ngIf="detalheOS.temOsRetorno" class="c-conteudo__texto"><span class="u-font-weight-600">Código do chamado de
            origem:
          </span>
          <a [routerLink]="['/historico-de-chamados', detalheOS.numserie, detalheOS.codContrato]"
            [queryParams]="{codigoOs: detalheOS.retornoOS}">
            {{detalheOS.retornoOS}}
          </a>
        </p>
        <br>
        <p *ngIf="detalheOS.codContrato" class="c-conteudo__texto"><span class="u-font-weight-600">Código do contrato:
          </span>{{detalheOS.codContrato}}</p>
        <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
        <ng-template #apnetworksCliente>
          <p *ngIf="detalheOS.nomeCliente||
        detalheOS.nomeFantasia" class="c-conteudo__texto"><span class="u-font-weight-600">Nome do
              cliente:</span>{{detalheOS.nomeCliente || detalheOS.nomeFantasia}}</p>
        </ng-template>
        <ng-template #kmDoBrasilCliente>
          <p *ngIf="detalheOS.nomeCliente||
        detalheOS.nomeFantasia" class="c-conteudo__texto"><span class="u-font-weight-600">Nome do
              cliente:</span>{{detalheOS.nomeFantasia || detalheOS.nomeCliente}}</p>
        </ng-template>
        <p *ngIf="detalheOS.nomeContato" class="c-conteudo__texto"><span class="u-font-weight-600">Nome do contato:
          </span>{{detalheOS.nomeContato}}
        </p>
        <p *ngIf="detalheOS.solicitante" class="c-conteudo__texto"><span class="u-font-weight-600">Solicitante:
          </span>{{detalheOS.solicitante}}</p>
        <p *ngIf="detalheOS.email" class="c-conteudo__texto"><span class="u-font-weight-600">Email:
          </span>{{detalheOS.email}}</p>
        <p *ngIf="detalheOS.celular" class="c-conteudo__texto"><span class="u-font-weight-600">Celular:
          </span>{{detalheOS.celular}}</p>
        <p *ngIf="detalheOS.telefonePrincipal" class="c-conteudo__texto"><span class="u-font-weight-600">Telefone
            principal:
          </span>{{detalheOS.telefonePrincipal}}</p>
        <p *ngIf="detalheOS.telefoneAlternativo" class="c-conteudo__texto"><span class="u-font-weight-600">Telefone
            alternativo:
          </span>{{detalheOS.telefoneAlternativo}}</p>
        <p class="c-conteudo__texto"><span class="u-font-weight-600">Endereço: </span>
          <span *ngIf="detalheOS.endereco">{{detalheOS.endereco}}</span>
          <span *ngIf="detalheOS.numero">, {{detalheOS.numero}}</span>
          <span *ngIf="detalheOS.complemento">, {{detalheOS.complemento}}</span>
          <span *ngIf="detalheOS.bairro">, {{detalheOS.bairro}}</span>
          <span *ngIf="detalheOS.cidade">, {{detalheOS.cidade}}</span>
          <span *ngIf="detalheOS.estado"> - {{detalheOS.estado}}</span>
          <span *ngIf="detalheOS.cep">, {{detalheOS.cep}}</span>
        </p>
        <p *ngIf="detalheOS.nomeDepartamentoOS" class="c-conteudo__texto"><span class="u-font-weight-600">Departamento
            informado no chamado:
          </span>{{detalheOS.nomeDepartamentoOS}}
        </p>
        <br>
        <p *ngIf="detalheOS.numserie" class="c-conteudo__texto"><span class="u-font-weight-600">Número de série:
          </span>{{detalheOS.numserie}}
        </p>
        <p *ngIf="detalheOS.marca" class="c-conteudo__texto"><span class="u-font-weight-600">Marca do equipamento:
          </span>{{detalheOS.marca}}
        </p>
        <p *ngIf="detalheOS.modelo" class="c-conteudo__texto"><span class="u-font-weight-600">Modelo do equipamento:
          </span>{{detalheOS.modelo}}
        </p>
        <p *ngIf="detalheOS.dataAbertura" class="c-conteudo__texto"><span class="u-font-weight-600">Data de abertura:
          </span>{{detalheOS.dataAbertura
          |
          date: "dd/MM/yyyy"}}</p>
        <p *ngIf="detalheOS.prazoMaximo " class="c-conteudo__texto"><span class="u-font-weight-600">Data de atendimento:
          </span>{{detalheOS.prazoMaximo | date:
          "dd/MM/yyyy"}}</p>
        <p *ngIf="detalheOS.status" class="c-conteudo__texto"><span class="u-font-weight-600">Status do chamado:
          </span>{{detalheOS.status}}
        </p>
        <p *ngIf="detalheOS.categoria" class="c-conteudo__texto"><span class="u-font-weight-600">Categoria do chamado:
          </span>{{detalheOS.categoria}}</p>
        <p *ngIf="detalheOS.motivoOS" class="c-conteudo__texto"><span class="u-font-weight-600">Motivo do chamado:
          </span>{{detalheOS.motivoOS}}
        </p>
        <p *ngIf="detalheOS.condicaoEquipamento" class="c-conteudo__texto"><span class="u-font-weight-600">Condição do
            equipamento:
          </span>{{detalheOS.condicaoEquipamento}}</p>
        <p *ngIf="detalheOS.observacao" class="c-conteudo__texto"><span class="u-font-weight-600">Observação:
          </span>{{detalheOS.observacao}}</p>
        <p *ngIf="detalheOS.observacaoDefeito" class="c-conteudo__texto"><span class="u-font-weight-600">Reparo
            Realizado:
          </span>{{detalheOS.observacaoDefeito}}</p>
      </app-datails-card>
    </ng-container>
    <!--<app-modal-general [titulo]="'Enviar mensagem'" [botao]="'Fechar'"
        [mensagem]="'Escreva sua mensagem no campo abaixo e se necessário anexe as imagens também abaixo.'"
        (cliqueBotao)="closeModal()">
        <div class="modal__content">
          <div class="content">
            <p class="titulo">Mensagem</p>
            <textarea placeholder="Digite aqui..."></textarea>
          </div>

          <div class="div__anexar__imagem">
            <p class="titulo">Imagens</p>
            <button class="botao__selecionar__arquivo">
              <div class="image.pngcustom-file">
                <input class="custom-file-input" id="customFile" type="file" (change)="inputFileChange($event)">
                <label class="custom-file-label" for="customFile" tabindex="0" id="customFileLabel">
                  {{ !foto? ' Selecionar arquivo' : foto }}
                </label>
              </div>
            </button>
            <div>
              <app-botao-submit>Enviar</app-botao-submit>
            </div>
          </div>
        </div>
      </app-modal-general>-->

    <!-- <div>
        <h5>Histórico</h5>

        <div class="div__historico__todos">
          <div class="div__historico">
            <div class="div__imagens__historico">
              <img src="../../../../assets/images/simbolos/blueIcon.svg" alt="blue icon" class="imagem__bolinha">
              <img src="../../../../assets/images/simbolos/iconeHistorico.svg" alt="retangulo cinza"
                class="imagem__barrinha">
            </div>

            <div class="div__historicos">
              <p>
                12:30 <br />
                <span>Contador:</span>
              </p>
            </div>
          </div>
        </div>

        <app-message-card>
          <app-mensagem [imagemInserida]="false">
          </app-mensagem>
          <app-botao-responder (click)="openModal();"></app-botao-responder>
        </app-message-card>
      </div> -->
    <app-listagem-vazia *ngIf="!detalhesOS.registros.length"></app-listagem-vazia>
  </div>
  <app-paginacao nomeDaLista="Detalhes do chamado" [(dados)]="detalhesOS" (dadosChange)="getOSDetalhada()"
    *ngIf="this.detalhesOS.registros.length"></app-paginacao>
</app-page-container>